import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../components/Button";
import Card from "../components/Card";
import { Stack } from "../components/Layout";
import PageShell from "../components/PageShell";
import { Heading, Text } from "../components/Typography";
import { isAuthenticated } from "../services/authStorage";

const HeroCard = styled(Card)`
  text-align: center;
`;

function Home() {
  const navigate = useNavigate();

  function handleDashboardButton() {
    if (isAuthenticated()) {
      navigate("/UserDashboard");
    } else {
      navigate("/SignIn");
    }
  }

  return (
    <PageShell>
      <HeroCard padding={5}>
        <Stack $gap={4} $align="center">
          <Stack $gap={2} $align="center">
            <Heading $size="3xl">Welcome to yourdasa</Heading>
            <Text $muted $size="lg">
              Sentiment analysis for small business using social media
            </Text>
          </Stack>
          <Stack $gap={2} $align="center" $fullWidth>
            <Button type="button" onClick={() => navigate("/LearnMore")}>
              Learn more
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={handleDashboardButton}
            >
              Dashboard
            </Button>
            <Button
              type="button"
              variant="ghost"
              onClick={() => navigate("/CreateUser")}
            >
              No account? Create a new user
            </Button>
          </Stack>
        </Stack>
      </HeroCard>
    </PageShell>
  );
}

export default Home;
